const callBlockingApps = {
  slug: 'call-blocking-apps',
  title: 'Call blocking apps for Android and iOS',
  description:
    'Compare built-in phone blocking, carrier tools, and third-party apps to reduce spam and scam calls in Australia.',
  category: 'guides',
  guideType: 'comparison',
  readMinutes: 4,
  partnerTip: 'none',
  relatedSlugs: ['managing-unwanted-calls', 'protecting-yourself-phone-scams-australia'],
  sections: [
    {
      type: 'paragraph',
      text: 'No app blocks 100% of scam calls, but layering tools reduces noise and risk.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Built-in phone features',
    },
    {
      type: 'list',
      items: [
        'iOS: Silence Unknown Callers, block specific numbers',
        'Android: caller ID & spam protection (Google), block list in Phone app',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Carrier services',
    },
    {
      type: 'paragraph',
      text: 'Telstra, Optus, Vodafone and others offer scam/ spam filtering add-ons. Check your plan — some are free, some are monthly fees.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Third-party apps',
    },
    {
      type: 'list',
      items: [
        'Community caller-ID apps with crowd-sourced labels',
        'Dedicated block lists updated from reported scam campaigns',
        'Review privacy policies — some apps upload your contact list',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Combine with lookup',
    },
    {
      type: 'paragraph',
      text: 'When you are unsure, search the number on WhoDatNumber before answering. Block and report if others flag it as a scam.',
    },
    {
      type: 'lookupCta',
    },
  ],
};

export default callBlockingApps;

